module.exports = __webpack_public_path__ + "static/media/Reptil.f9c05bd7.m4a";